import request from '@/utils/request'
import { parseStrEmpty } from "@/utils/ruoyi";

// 查询用户列表
export function listUser(query) {
  return request({
    url: '/system/user/list',
    method: 'get',
    params: query
  })
}

// 查询用户详细
export function getUser(userId) {
  return request({
    url: '/system/user/' + parseStrEmpty(userId),
    method: 'get'
  })
}

// 新增用户
export function addUser(data) {
  return request({
    url: '/system/user',
    method: 'post',
    data: data
  })
}

// 修改用户
export function updateUser(data) {
  return request({
    url: '/system/user',
    method: 'put',
    data: data
  })
}

// 删除用户
export function delUser(userId) {
  return request({
    url: '/system/user/' + userId,
    method: 'delete'
  })
}

// 用户密码重置
export function resetUserPwd(userId, password) {
  const data = {
    userId,
    password
  }
  return request({
    url: '/system/user/resetPwd',
    method: 'put',
    data: data
  })
}

// 用户状态修改
export function changeUserStatus(userId, status) {
  const data = {
    userId,
    status
  }
  return request({
    url: '/system/user/changeStatus',
    method: 'put',
    data: data
  })
}

// 查询用户个人信息
export function getUserProfile() {
  return request({
    url: '/mmscm-system/user/info',
    method: 'get'
  })
}
// 上传头像
export const uploadAuth = (params) => request({
  url: '/mmscm-resource/oss/endpoint/upload-auth',
  method: 'get',
  params
})

export const ossUpload = (url, formData) => {
  return request({
      url: url,
      method: 'post',
      data: formData,
      withCredentials: false
  })
}

export const updatePassword = (oldPassword, newPassword, newPassword1) => {
  return request({
    url: '/mmscm-system/user/update-password',
    method: 'post',
    params: {
      oldPassword,
      newPassword,
      newPassword1,
    }
  })
}

export const getSelect = (params) => {
  return request({
    url: '/mmscm-system/bankaccount/select',
    method: 'get',
    params: {
      ...params
    }
  })
}

export const updateInfo = (row) => {
  return request({
    url: '/mmscm-system/user/update-info',
    method: 'post',
    data: row
  })
}

// 修改用户个人信息
export function updateUserProfile(data) {
  return request({
    url: '/system/user/profile',
    method: 'put',
    data: data
  })
}

// 用户密码重置
export function updateUserPwd(data) {
//   const data = {
//     oldPassword,
//     newPassword
//   }
  return request({
    url: '/system/user/profile/updatePwd',
    method: 'put',
    data: data
  })
}

// 用户头像上传
export function uploadAvatar(data) {
  return request({
    url: '/system/user/profile/avatar',
    method: 'post',
    data: data
  })
}

// 查询授权角色
export function getAuthRole(userId) {
  return request({
    url: '/system/user/authRole/' + userId,
    method: 'get'
  })
}

// 保存授权角色
export function updateAuthRole(data) {
  return request({
    url: '/system/user/authRole',
    method: 'put',
    params: data
  })
}

// 查询部门下拉树结构
export function deptTreeSelect() {
  return request({
    url: '/system/user/deptTree',
    method: 'get'
  })
}


export const bankRemove = (ids) => {
  return request({
    url: '/mmscm-system/bankaccount/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const bankAdd = (row) => {
  return request({
    url: '/mmscm-system/bankaccount/save',
    method: 'post',
    data: row
  })
}

export const bankUpdate = (row) => {
  return request({
    url: '/mmscm-system/bankaccount/update',
    method: 'post',
    data: row
  })
}
export const getDetailBank = (id) => {
  return request({
    url: '/mmscm-system/bankaccount/detail',
    method: 'get',
    params: {
      id
    }
  })
}